// src/components/home/WhyChooseSection.js
import React from 'react';
import { motion } from 'framer-motion';
import { FaLaptopCode, FaUsers, FaIndustry, FaLightbulb, FaHandsHelping, FaUserGraduate } from 'react-icons/fa';
import Section from '../common/Section';
import Heading from '../common/Heading';

const WhyChooseSection = () => {
  const features = [
    {
      icon: <FaLaptopCode />,
      title: 'Hands-on Practical Training',
      description: 'We prioritize practical training, building on students theoretical knowledge with real-world problem-solving exercises and projects.'
    },
    {
      icon: <FaUsers />,
      title: 'Peer-to-Peer Learning',
      description: 'Our youth-led approach creates a fun-filled learning environment that maintains motivation throughout the training period.'
    },
    {
      icon: <FaIndustry />,
      title: 'Industry-Relevant Skills',
      description: 'We teach the advanced digital skills that employers are actively looking for, enhancing your competitive advantage in the job market.'
    },
    {
      icon: <FaLightbulb />,
      title: 'Entrepreneurship Focus',
      description: 'Develop not only technical skills but also the entrepreneurial mindset needed to create your own opportunities.'
    },
    {
      icon: <FaHandsHelping />,
      title: 'Field Work Experience',
      description: 'Get hands-on experience with real-world projects in communities, connecting your learning to actual societal needs.'
    },
    {
      icon: <FaUserGraduate />,
      title: 'Expert Mentorship',
      description: 'Learn from experienced professionals who provide guidance and insights from their industry experience.'
    }
  ];
  
  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.3
      }
    }
  };
  
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    }
  };
  
  return (
    <Section background="gradient-blue" className="overflow-hidden">
      <div className="text-center mb-12">
        <Heading level={2} color="white" align="center" className="mb-4" withAccent>
          Why Choose Afrovate Tech Hub
        </Heading>
        <p className="text-lg text-white text-opacity-90 max-w-2xl mx-auto">
          Our unique approach to digital skills training sets us apart and ensures your success
        </p>
      </div>
      
      <motion.div
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
      >
        {features.map((feature, index) => (
          <motion.div
            key={index}
            variants={itemVariants}
            className="bg-white bg-opacity-10 backdrop-blur-sm rounded-lg p-6 border border-white border-opacity-20 shadow-xl transform transition-all duration-300 hover:-translate-y-2"
          >
            <div className="flex items-start">
              <div className="mr-4 bg-secondary p-3 rounded-full text-white text-xl">
                {feature.icon}
              </div>
              <div>
                <h3 className="text-xl font-bold text-white mb-3">{feature.title}</h3>
                <p className="text-white text-opacity-80 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </Section>
  );
};


export default WhyChooseSection;